import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    tooltip: {
        fontSize: '25px'
    },
    foodPackages_container: {
        display: 'flex',
        flexDirection: 'column',
        width:'100%',
        height: '100%',
    },
    items_inventory_container: {
        display: 'flex',
        flexDirection: 'column',
    },
    items_inventory_table: {
        height:'100%',
        width:'100%',
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'auto',
    },
    elements_container: {
        height:'100%',
        marginBottom: '8px',
        width:'100%'
    },
    reference_items_info_container: {
        position: 'relative',
        marginTop: '4px',
        marginLeft:'4px',
        marginRight:'4px',
        display: 'grid',
        gridTemplateColumns: 'auto 90px 20px',
        backgroundColor: theme.palette.common.white,
        borderRadius: 4,
        paddingLeft: 8,
        paddingRight: 8,
        border: `1px solid ${theme.palette.grey["400"]}`,
        borderLeft: `8px solid ${theme.palette.success.light}`,
        "&:hover": {
            backgroundColor: `${theme.palette.grey[200]}`,
            cursor: 'pointer',
            border: `1px solid ${theme.palette.secondary.light}`,
            borderLeft: `8px solid ${theme.palette.secondary.light}`,
        }
    },
    column: {
        display: 'flex',
        alignItems: 'center'
    },
    items_inventory_info_container_small: {
        position: 'relative',
        marginTop: '4px',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
        placeItems: 'stretch',
        rowGap: 16,
        columnGap: 16,
        backgroundColor: theme.palette.common.white,
        borderRadius: 4,
        padding: 8,
        border: `1px solid ${theme.palette.grey["400"]}`,
        borderLeft: `8px solid ${theme.palette.success.light}`,
    },
    inactive: {
        borderLeft: `8px solid ${theme.palette.grey["300"]}`,
        backgroundColor: `${theme.palette.grey["300"]}8c`,
        opacity: '0.8'
    },
    menu_container: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'flex-start',
        "& > *": {
            marginLeft: '4px'
        }
    },
    menu_container_small: {
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        "& > *": {
            marginLeft: '4px'
        }
    },
    filter_container: {
        display: "flex",
        marginTop: '8px',
    },
    tools_container: {
        display: 'flex',
        justifyContent: 'end',
    },
    search_btn: {
        justifySelf: 'flex-end',
        marginLeft: '5px'
    },
    filter_buttons_container: {
        display: "flex",
        justifyContent: "end",
    },

}));

export {useStyles}